import React, { useState } from "react";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/Footer";
import ShowCase from "../../components/ShowCase/ShowCase";
import { useSelector } from "react-redux";
import { usePostRendering } from "../../hooks/useGetRendering";
import ListingCard from "../../components/ListingCard/ListingCard";
import SearchInput from "../../components/ListingSearchInput/input";
import { useTranslation } from "react-i18next";
import { FaFilter } from "react-icons/fa";
import { useLocation, useParams } from "react-router-dom";
import { useLayoutEffect } from "react";
import datahubBg from '../../utils/assets/images/datahubbg.png'
import LoadingPopup from "../../components/LoadingPopup/LoadingPopup";
import { Helmet } from "react-helmet";
const ForumPublications = () => {
    const { t, i18n } = useTranslation()
    let lang = i18n.language
    const {id} = useParams()
    const [ForumPublications, setForumPublications] = useState()
    const [pageSize, setPageSize] = useState(4)
    const [searchText, setSearchText] = useState()
    const [searchYears, setSearchYears] = useState([])
    const [favoriteRerender, setFavoriteRerender] = useState(false)
    const user = useSelector((state) => state.userDataReducer.user)
    usePostRendering('PolicyForumAPI/GetDocumentPolicyForum', setForumPublications, {
        eventPolicyForumId: id ? parseInt(id) : null,
        titleA: lang === 'ar-EG' ? searchText : '',
        titleE: lang === 'en-US' ? searchText : '',
        lang: lang === 'ar-EG' ? '' : 'en',
        ownerId:user,
        searchYears: searchYears.length === 0 ? null : searchYears,
        pageSize: pageSize,

    }, [pageSize, favoriteRerender, user, searchYears, lang])
   
    // show responsive filter
    const [resFilter, setResFilter] = useState(false)
    const location = useLocation()
    useLayoutEffect(() => {
      window.scrollTo(0, 0)
    }, [location.pathname])
    return (
        <>
        <Helmet>
            <title>{t('Forumpublications')}</title>
        </Helmet>
         {ForumPublications?.result ?    <>
            <NavBar lang={lang} t={t} />
            <ShowCase title={t('Forumpublications')} description={t('ForumPublicationsDesc')} bg={datahubBg} />
            <div className="ctr">
                <div className="filter-res-results">
                    <div
                        className="filter-res-results-title"
                        onClick={(e) => {
                            setResFilter(true)
                        }}
                    >
                        <span>
                            <FaFilter size={20} />
                        </span>
                        <span className="mx-2">{t('ResponsiveFilter')}</span>
                    </div>
                    <div className="filter-res-results-number-reset">
                        <span>({`${searchYears?.length}`})</span>
                        <span
                            className="mx-2"
                            onClick={(e) => {

                                setSearchYears([])
                            }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                            >
                                <g
                                    id="Group_603"
                                    data-name="Group 603"
                                    transform="translate(-268 -344)"
                                >
                                    <rect
                                        id="Rectangle_2231"
                                        data-name="Rectangle 2231"
                                        width="24"
                                        height="24"
                                        rx="4"
                                        transform="translate(268 344)"
                                        fill={
                                            searchYears?.length > 0
                                                ? '#df1e26'
                                                : 'rgba(200, 200, 200, 1)'
                                        }
                                    />
                                    <line
                                        id="Line_155"
                                        data-name="Line 155"
                                        x2="13"
                                        y2="13"
                                        transform="translate(273.5 350.5)"
                                        fill="none"
                                        stroke="#fff"
                                        stroke-linecap="round"
                                        stroke-width="3"
                                    />
                                    <line
                                        id="Line_156"
                                        data-name="Line 156"
                                        x1="13"
                                        y2="13"
                                        transform="translate(273.5 350.5)"
                                        fill="none"
                                        stroke="#fff"
                                        stroke-linecap="round"
                                        stroke-width="3"
                                    />
                                </g>
                            </svg>
                        </span>
                    </div>
                </div>
                <div className="row forum-publications-listing-row">
                    <div className="col-xl-9 col-lg-8  col-md-7 col-12">
                        <ListingCard
                            data={ForumPublications?.result?.items}
                            favoriteRerender={favoriteRerender}
                            setFavoriteRerender={setFavoriteRerender}
                        />
                        <div className="load-more-btn-wrapper">
                            <button
                                className="load-more-btn"
                                onClick={() => setPageSize(pageSize + 4)}
                                style={{
                                    display:
                                    ForumPublications?.result?.items?.length ===
                                    ForumPublications?.result?.totalCount
                                            ? 'none'
                                            : 'flex',
                                }}
                            >
                                {t('View-More')}
                            </button>
                        </div>
                    </div>
                    <div
                        className={
                            resFilter
                                ? 'res-filter'
                                : 'col-xl-3 col-lg-4 col-md-5 col-12 filter-col-none '
                        }
                    >
                        <SearchInput searchText={searchText} setSearchText={setSearchText} setSearchData={setForumPublications} object={
                          
                          {
                            titleA: lang === 'ar-EG' ? searchText : '',
                            titleE: lang === 'en-US' ? searchText : '',
                            lang: lang === 'ar-EG' ? '' : 'en',
                            ownerId:user,
                            searchYears: searchYears.length === 0 ? null : searchYears,
                            pageSize: pageSize,
                    
                        }

                        }
                            url={`PolicyForumAPI/GetDocumentPolicyForum`} />
                 

                    </div>
                    {resFilter && (
                        <div
                            className="res-close-res-filter"
                            onClick={(e) => setResFilter(false)}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                            >
                                <g
                                    id="Group_603"
                                    data-name="Group 603"
                                    transform="translate(-268 -344)"
                                >
                                    <rect
                                        id="Rectangle_2231"
                                        data-name="Rectangle 2231"
                                        width="24"
                                        height="24"
                                        rx="4"
                                        transform="translate(268 344)"
                                        fill="#df1e26"
                                    ></rect>
                                    <line
                                        id="Line_155"
                                        data-name="Line 155"
                                        x2="13"
                                        y2="13"
                                        transform="translate(273.5 350.5)"
                                        fill="none"
                                        stroke="#fff"
                                        stroke-linecap="round"
                                        stroke-width="3"
                                    ></line>
                                    <line
                                        id="Line_156"
                                        data-name="Line 156"
                                        x1="13"
                                        y2="13"
                                        transform="translate(273.5 350.5)"
                                        fill="none"
                                        stroke="#fff"
                                        stroke-linecap="round"
                                        stroke-width="3"
                                    ></line>
                                </g>
                            </svg>
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </> :<LoadingPopup/>}
        </>
       
     
    )
}
export default ForumPublications